<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneMutedByHost_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.4 9.348a6.45 6.45 0 0 0-1.537 2.057L4.72 5.259A3.86 3.86 0 0 1 8.53 2a3.87 3.87 0 0 1 3.87 3.871zM1.101 3.466l9.3 9.3a6.45 6.45 0 0 0 .034 2.903c-.561.33-1.208.524-1.907.524a3.87 3.87 0 0 1-3.87-3.87V8.846L.187 4.378a.646.646 0 0 1 .913-.912M16.681 20.571h.081a.7.7 0 0 1-.213 0z"
    />
    <path
        fill="currentColor"
        d="M9.173 18.738a6.3 6.3 0 0 0 2.37-.73 6.4 6.4 0 0 1-.675-1.116 4.9 4.9 0 0 1-2.34.592 5.166 5.166 0 0 1-5.161-5.162v-1.29a.645.645 0 0 0-1.29 0v1.29c0 3.337 2.554 6.057 5.806 6.386v2.647a.645.645 0 0 0 1.29 0z"
    />
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M16.429 9.143a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 7.5a.5.5 0 0 0 0-1h-.005a.5.5 0 1 0 0 1zm-.5-2.5a.5.5 0 1 0 1 0v-2a.5.5 0 1 0-1 0z"
        clip-rule="evenodd"
    />
</svg>
